import { gql } from '@apollo/client';

export const DELETE_LEASING_EXPENSE_TYPE = gql`
  mutation deleteLeasingExpenseType($expenseTypeId: Int!) {
    deleteLeasingExpenseType(expenseTypeId: $expenseTypeId) {
      commandId
    }
  }
`;

export const SAVE_LEASING_EXPENSE_TYPE = gql`
  mutation saveLeasingExpenseType($input: LeasingExpenseTypeInput!) {
    saveLeasingExpenseType(input: $input) {
      commandId
    }
  }
`;
